module.exports = __webpack_public_path__ + "img/navbar_background_test.7198be4b.svg";